<template>
  <div class="page-box decision-box">
    <div class="decision-head">
      <div class="decision-head-left">地面运行起飞前故障决策</div>
      <div class="decision-head-right">
        <div class="decision-head-bt"><img src="@/assets/images/yi.png"/>历史记录</div>
        <div class="decision-head-bt active"><img src="@/assets/images/yi2.png"/>回到首页</div>
      </div>
    </div>
    <div class="decision-page">
      <div class="decision-left">
        <div class="malfunction-page active">
          <div class="backlog-head">应急预案（待办事项）</div>
          <div class="malfunction-page-top">
            <div class="malfunction-page-top-li active">安全员</div>
            <div class="malfunction-page-top-li">飞行员</div>
            <div class="malfunction-page-top-li">乘务员</div>
          </div>
          <div class="backlog-ul">
            <div class="backlog-li">
              <div class="matter-head">紧急事件</div>
              <div class="matter-ul">
                <div class="matter-li" v-for="(item,index) in 6">
                  <div class="matter-laber">已完成</div>
                  <div class="matter-p">紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述</div>
                </div>
              </div>
              <div class="matter-bt">添加任务<img src="@/assets/images/tianjia.png"/></div>
            </div>
            <div class="backlog-li">
              <div class="matter-head">待办事项</div>
              <div class="matter-ul">
                <div class="matter-li">
                  <div class="matter-laber active">确认完成</div>
                  <div class="matter-p">紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述</div>
                </div>
              </div>
              <div class="matter-bt">添加任务<img src="@/assets/images/tianjia.png"/></div>
            </div>
            <div class="backlog-li">
              <div class="matter-head">下发事项</div>
              <div class="matter-ul">
                <div class="matter-li">
                  <div class="matter-laber active">确认完成</div>
                  <div class="matter-p">紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述紧急事件文案描述</div>
                </div>
              </div>
              <div class="matter-bt">添加任务<img src="@/assets/images/tianjia.png"/></div>
            </div>
          </div>
        </div>
      </div>
      <div class="decision-right">
        <div class="backlog-top">
          <div class="backlog-head">航班背景信息</div>
          <div class="information-box">
            <div class="information-left">
              <img src="@/assets/images/feigei.png"/>
              <div class="information-state">待机中</div>
            </div>
            <div class="information-text">
              <div class="information-p">设备编号：DB345232</div>
              <div class="information-p">飞机类别：A330</div>
              <div class="information-p">航  班 号：MU4532</div>
              <div class="information-p">飞机编号：B-2350/00712</div>
            </div>
          </div>
        </div>
        <div class="backlog-bottom">
          <div class="backlog-head">单兵视频流</div>
          <div class="backlog-video">
            <div class="video-box">
              <img src="@/assets/images/play.png"/>
              <div class="video-p">请打开单兵设备视频流功能</div>
            </div>
            <video></video>
          </div>
        </div>
        <div class="aircraft-bt active">结束本次事件协同</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "decision",
    data() {
        return {

        }
    }
  }
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/backlog/backlog.vue